import {PermissionEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {PermissionAction} from "./PermissionActionMenu";
import {usePermissionMutation} from "../../../hooks/usePermissionMutation";

export type UsePermissionActionProps = {}

export type UsePermissionActionResult = {
  onPermissionActionClick: (permission: PermissionEntity, action: PermissionAction) => void;
}

export const usePermissionAction = (props: UsePermissionActionProps = {}): UsePermissionActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deletePermission,
  } = usePermissionMutation()

  const _onPermissionActionClick = useCallback((permission: PermissionEntity, action: PermissionAction) => {

  }, [navigate, deletePermission])

  return {
    onPermissionActionClick: _onPermissionActionClick
  }
}
